import request from '../../axios';

const getDetailLabCard = async (guid: string) => {
  const {data}: {data: ILabDetailData} = await request.get(
    `api/v2/store/lab-detail/${guid}`,
  );

  return data;
};

export default getDetailLabCard;
